<template>
  <el-card>
    <template #header>
      <h4>{{$t('积分分类')}}</h4>
    </template>

    <div class="flex-end mb16" v-if="showAddBtn">
      <el-button type="primary" size="mini" @click="handleShowDialog()">{{$t('新增')}}</el-button>
    </div>

    <div style="height: 500px">
      <table-list
          :height="500"
          :search-params="searchForm"
          @query="loadList"
          :data="dataList"
          @selection-change="selection = $event"
          ref="list">
        <el-table-column type="index" width="80" />
        <el-table-column :label="$t('名称')" prop="name" />
        <el-table-column :label="$t('积分数')" prop="integral" />
        <el-table-column :label="$t('创建时间')">
          <template v-slot="{row}">
            {{row.createTime | formatDate}}
          </template>
        </el-table-column>
        <el-table-column :label="$t('操作')">
          <template v-slot="{row}">
            <div class="fb-link-flex">
              <el-link type="primary" :underline="false" @click="handleShowDialog(row)">{{$t('编辑')}}</el-link>
              <el-link type="danger" :underline="false" @click="handleDelete(row)">{{$t('删除')}}</el-link>
            </div>
          </template>
        </el-table-column>
      </table-list>
    </div>

    <!--  新增/编辑积分分类  -->
    <vip-level-form
        type="integral"
        ref="levelForm"
        @save="handleAddOrEditSubmit"
        :data="currentRow"
        :title="isEdit? $t('编辑积分') : $t('新增积分')"
        :is-edit="isEdit" />

  </el-card>
</template>

<script>
import TableList from "@/components/table-list/TableList";
import {request, requestByTip} from "@/config/request";
import VipLevelForm from "@/components/level/VipLevelForm";
export default {
  name: "UserIntegralCategoryList",
  components: {VipLevelForm, TableList},
  data() {
    return {
      searchForm: {},
      dataList: [],
      selection: [],
      currentRow: {},
      isEdit: false,
    }
  },
  methods: {
    // 添加/编辑提交
    async handleAddOrEditSubmit(data) {
      try {
        if(this.isEdit) data.code = this.currentRow.code;
        const action = this.$api.userVipIntegralRule[this.isEdit ? 'update' : 'add'];
        await request(action, data);
        this.$message.success(this.$t('操作成功'));
        this.$refs.list.handleRequest();
      } catch (e) {
        console.log(e);
      }
    },

    // 打开新增/编辑弹窗
    handleShowDialog(row) {
      if(row) {
        this.isEdit = true;
        this.currentRow = {...row};
      } else {
        this.isEdit = false;
      }
      this.$refs.levelForm.showDialog = true
    },


    async handleDelete(row) {
      try {
        await requestByTip(this.$api.userVipIntegralRule.delete, {code: row.code});
        this.$message.success(this.$t('操作成功'))
        this.$refs.list.handleRequest(1);
      } catch (e) {
        console.error(e);
      }
    },

    async loadList(params, setTotal) {
      try {
        const res = await request(this.$api.userVipIntegralRule.list, params);
        for (const key in res) {
          if(Array.isArray(res[key])) {
            this.dataList = res[key];
          }
        }
        setTotal(res.pager.itemCount);
      } catch (e) {
        console.log(e);
      }
    }
  },
  computed: {
    showAddBtn() {
      const dict = this.$store.getters.getDictByFlag("INTEGRAL_ADD_BTN");
      if(!dict.length) return false;
      return dict[0].dictValue === "1";
    }
  }
}
</script>

<style scoped>

</style>
